export const SYNC_ZWAVE_DEVICES_BY_GROUPS = '@@zWaveDevicesByGroups/syncZWaveDevicesByGroups'

export const RESET_ZWAVE_DEVICES_BY_GROUPS = '@@zWaveDevicesByGroups/reset'

export const UPDATE_ZWAVE_DEVICES_BY_GROUPS = '@@zWaveDevicesByGroups/updateZWaveDevicesByGroups'
